import { useEffect, useState } from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import Button from 'components/ui/Button/Button';
import { mediaMdMin } from 'helpers/breakpoints';
import useRudderStackTrack from 'hooks/useRudderStackTrack';

const GetMyBoatLogo = () => (
  <svg width="138" height="24" viewBox="0 0 138 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_14033)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9239 23.6453C15.9231 24.5038 20.7035 21.8413 22.8691 17.4151C22.9556 17.2392 23.0778 17.0852 23.2275 16.9638C23.3771 16.8425 23.5504 16.7567 23.7351 16.7128C25.3811 16.3176 26.7167 14.9418 27.012 13.1195C27.0979 12.5906 27.0749 12.0701 26.9977 11.5694C26.9436 11.2133 26.7589 11.0514 26.4756 11.0031C26.1779 10.9517 25.9558 11.0671 25.7871 11.4C25.5315 11.904 24.5812 12.3615 23.9039 12.7642C23.295 13.1261 23.0522 13.6184 22.7148 13.709C22.3685 13.8019 21.856 13.3527 21.2996 13.1826C20.6215 12.975 20.128 12.9618 19.5963 12.5557C19.5046 12.4474 19.3814 12.3735 19.2454 12.3455C19.1096 12.3175 18.9686 12.3369 18.8443 12.4007C18.72 12.4645 18.6193 12.5693 18.5577 12.6987C18.4961 12.8282 18.477 12.9751 18.5035 13.117C18.6663 14.1089 19.1477 15.0135 19.8685 15.6824C20.4909 16.1881 20.6167 16.805 20.1901 17.5497C19.2891 19.1172 17.5739 19.4426 16.15 19.4426C13.5075 19.4426 11.8439 17.3106 11.7461 15.0033C11.7238 14.4686 11.8065 14.1871 12.1973 14.1431C12.6534 14.0917 12.8914 14.1431 13.3673 14.1664C13.673 14.1813 13.9738 14.2104 14.266 14.271C14.9378 14.4105 15.0889 14.085 15.124 13.8227C15.147 13.6525 15.0683 13.4217 14.9839 13.288C14.5063 12.535 14.4824 12.3482 13.7375 11.6997C13.5719 11.5553 13.3801 11.2913 13.5146 11.0962C13.8011 10.6802 14.6146 10.2153 16.602 9.85078C17.4036 9.70387 18.5823 9.68809 19.1689 9.74205C19.7858 9.79849 20.5697 9.8566 21.0951 10.001C21.8106 10.1978 22.4107 9.6142 22.5039 9.04132C22.5818 8.55972 22.3765 8.18612 21.9896 7.72787C21.7111 7.3974 21.4938 7.2023 21.3704 6.11302C21.1627 4.28647 19.7945 3.13575 19.118 2.61602C17.655 1.4902 16.571 1.05017 14.6424 0.718899C12.2773 0.307913 9.84813 0.687128 7.70195 1.80237C7.09737 2.10791 6.4049 2.16568 5.76146 1.96427C5.5195 1.88932 5.27404 1.82724 5.02603 1.77829C3.43954 1.46434 1.79772 1.75577 0.400081 2.59941C0.321492 2.64687 0.253873 2.71179 0.202018 2.78956C0.150162 2.86733 0.115339 2.95603 0.100015 3.04941C0.042708 3.40226 0.199506 3.66794 0.618165 3.7958C1.24854 3.98842 1.80649 4.42844 2.10655 5.07687C2.32302 5.5604 2.44133 6.08538 2.45407 6.61887C2.46681 7.15236 2.3737 7.68285 2.18057 8.17703C1.93955 8.85507 1.76021 9.55529 1.64491 10.2684C0.848987 15.1719 3.16275 19.8702 7.10499 22.2306C8.28646 22.9367 9.57996 23.4165 10.9239 23.6453Z"
        fill="#0AE9F5"
      />
      <path
        d="M40.3746 5.41744C43.9947 5.41744 45.9152 7.53886 45.9152 11.5787V13.9258C45.9152 18.101 44.061 20.0194 40.0655 20.0194C39.028 20.0194 37.9685 19.9065 36.7323 19.6808V16.95C37.8581 17.2208 38.8515 17.3562 39.8006 17.3562C42.2067 17.3562 43.1559 16.4761 43.1559 14.2418C42.6041 15.1671 41.3458 15.7539 39.933 15.7539C36.8868 15.7539 34.8781 13.7227 34.8781 10.6308C34.8781 7.53886 37.2179 5.41744 40.3746 5.41744ZM40.3746 13.0908C42.0302 13.0908 43.1117 12.1203 43.1117 10.6308C43.1117 9.14126 42.0302 8.08053 40.3746 8.08053C38.719 8.08053 37.6815 9.11871 37.6815 10.6308C37.6815 12.1429 38.7631 13.0908 40.3746 13.0908ZM52.3388 5.41744C55.5837 5.41744 57.6366 7.67427 57.6366 11.2627C57.6366 11.4433 57.6145 11.7592 57.5925 12.0978H49.4912C49.7561 13.6325 50.7936 14.4449 52.5154 14.4449C53.6633 14.4449 54.6124 13.9935 55.3851 13.0908L57.173 14.9189C56.0472 16.2955 54.5021 16.9726 52.4713 16.9726C48.9173 16.9726 46.7098 14.7834 46.7098 11.2627C46.7098 7.74198 49.0277 5.41744 52.3388 5.41744ZM54.7449 9.95376C54.6124 8.66729 53.7295 7.94511 52.2946 7.94511C50.8598 7.94511 49.9327 8.64475 49.5795 9.95376H54.7449ZM58.3421 2.66406H61.1456V5.68826H64.9644V8.26111H61.1456V11.5787C61.1456 13.4293 61.8299 14.129 63.6841 14.129H64.9644V16.7018H63.066C59.8873 16.7018 58.3421 15.0994 58.3421 11.7367V2.66406ZM70.5271 5.41744C72.1166 5.41744 73.264 5.98165 74.1916 7.22293C74.9421 6.07192 76.2666 5.41744 77.8337 5.41744C80.7253 5.41744 82.4915 7.3358 82.4915 10.4728V16.7018H79.7322V10.6533C79.7322 8.84787 79.1582 8.12569 77.7014 8.12569C76.2445 8.12569 75.5602 8.87042 75.5602 10.6533V16.7018H72.8009V10.6533C72.8009 8.84787 72.1828 8.12569 70.6154 8.12569C69.2026 8.12569 68.5846 8.89304 68.5846 10.6533V16.7018H65.8253V10.4728C65.8253 7.26806 67.5471 5.41744 70.5271 5.41744ZM83.2199 5.68826H85.9792V10.6533C85.9792 12.2106 86.8841 13.0908 88.4952 13.0908C90.1071 13.0908 91.034 12.2332 91.034 10.6533V5.68826H93.7933V13.9258C93.7933 18.101 91.9388 20.0194 87.944 20.0194C86.9061 20.0194 85.8469 19.9065 84.6106 19.6808V16.95C85.736 17.2208 86.7297 17.3562 87.6786 17.3562C90.1292 17.3562 91.1002 16.4761 91.1002 14.2418C90.5041 15.2122 89.4008 15.7539 88.0763 15.7539C85.1185 15.7539 83.2199 13.8581 83.2199 10.8565V5.68826ZM94.654 2.66406H97.4133V6.92953C98.0756 5.93651 99.2016 5.41744 100.636 5.41744C103.771 5.41744 105.957 7.78715 105.957 11.195C105.957 14.6029 103.616 16.9726 100.217 16.9726C96.8172 16.9726 94.654 14.5578 94.654 11.195V2.66406ZM100.305 14.3095C101.983 14.3095 103.153 13.0231 103.153 11.195C103.153 9.36693 102.027 8.05798 100.305 8.05798C98.5835 8.05798 97.4574 9.34438 97.4574 11.195C97.4574 13.0456 98.6276 14.3095 100.305 14.3095ZM112.336 5.41744C115.691 5.41744 118.031 7.78715 118.031 11.195C118.031 14.6029 115.691 16.9726 112.336 16.9726C108.98 16.9726 106.685 14.6029 106.685 11.195C106.685 7.78715 108.98 5.41744 112.336 5.41744ZM112.336 14.3095C114.013 14.3095 115.183 13.0231 115.183 11.195C115.183 9.36693 114.013 8.08053 112.336 8.08053C110.658 8.08053 109.444 9.36693 109.444 11.195C109.444 13.0231 110.614 14.3095 112.336 14.3095ZM124.498 5.41744C127.743 5.41744 130.061 7.83231 130.061 11.195V16.7018H127.523V15.122C126.861 16.273 125.536 16.9726 124.079 16.9726C120.944 16.9726 118.759 14.6029 118.759 11.195C118.759 7.78715 121.099 5.41744 124.498 5.41744ZM124.41 14.332C126.088 14.332 127.258 13.0456 127.258 11.195C127.258 9.34438 126.088 8.08053 124.41 8.08053C122.733 8.08053 121.563 9.36693 121.563 11.195C121.563 13.0231 122.689 14.332 124.41 14.332ZM131.01 2.66406H133.813V5.68826H137.632V8.26111H133.813V11.5787C133.813 13.4293 134.498 14.129 136.351 14.129H137.632V16.7018H135.733C132.555 16.7018 131.01 15.0994 131.01 11.7367V2.66406Z"
        fill="#232626"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_14033">
        <rect width="138" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const BoatsetterLogo = () => <img alt="boatsetter logo" src="/images/logo-bs-blue.svg" />;

const BoatsetterAndGmbPage = () => {
  const rudderTrack = useRudderStackTrack();
  const [count, setCount] = useState(10);
  setTimeout(() => {
    rudderTrack('bs_gmb_redirect', {
      type: 'auto',
    });
    window.location.href = 'https://www.getmyboat.com/';
  }, 10000);

  useEffect(() => {
    const secondInterval = setInterval(() => {
      setCount((prev) => {
        if (prev <= 0) {
          clearInterval(secondInterval);
        }
        return prev <= 0 ? 0 : prev - 1;
      });
    }, 1000);

    return () => clearInterval(secondInterval);
  }, []);

  const goToGMB = () => {
    rudderTrack('bs_gmb_redirect', {
      type: 'click',
    });
    window.location.href = 'https://www.getmyboat.com/';
  };

  return (
    <div>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <PageHeader>
        <BoatsetterLogo />
        <VerticalDivider />
        <GetMyBoatLogo />
      </PageHeader>
      <ContentContainer>
        <h1>We&#39;re teaming up</h1>
        <p>
          Boatsetter and Getmyboat have teamed up to provide the best service for destinations outside the United
          States.
        </p>
        <ButtonVersionWrapper>
          <Button text="Visit Getmyboat.com" role="link" onClick={goToGMB} />
          <br />
          or you&#39;ll be redirected in {count}
        </ButtonVersionWrapper>
      </ContentContainer>
    </div>
  );
};

const PageHeader = styled.div`
  height: 66px;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 16px;
  border: 1px solid #eef1f5;

  img,
  svg {
    height: 24px;
  }
`;

const ContentContainer = styled.div`
  padding: 24px 24px 90px 24px;
  text-align: center;
  height: calc(100vh - 66px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #17263c;
    margin-bottom: 12px;
  }

  @media ${mediaMdMin} {
    h1 {
      font-size: 36px;
      line-height: 44px;
    }
  }

  p {
    line-height: 24px;
    color: #434c5c;
    max-width: 448px;
    margin-bottom: 32px;
  }

  span {
    font-size: 12px;
    line-height: 16px;
  }

  a {
    text-decoration: underline;
  }
`;

const ButtonVersionWrapper = styled.span`
  button {
    margin-bottom: 32px;
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: #dbdfe5;
  margin: 0 12px;
`;

export default BoatsetterAndGmbPage;
